import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//组件懒加载，下载js时显示spin状态。
const router = new Router({
    mode: 'hash',
    routes: []
})

//禁用重复警告
'push,replace'.split(',').map(method => router[method] = function () {
    return Router.prototype[method].apply(this, arguments).catch(t => 0)
})


export default router;
